/**
 * Hex color values for object identification (studies, etc.)
 * Organized by darkness: Light (400), Medium (600), Dark (800)
 * 51 total colors: 17 color families × 3 variants
 */
export const OBJECT_COLORS = [
    // LIGHT COLORS (400 variants)
    '#f87171', // Red
    '#fb923c', // Orange
    '#fbbf24', // Amber
    '#facc15', // Yellow
    '#a3e635', // Lime
    '#4ade80', // Green
    '#34d399', // Emerald
    '#2dd4bf', // Teal
    '#22d3ee', // Cyan
    '#38bdf8', // Sky
    '#60a5fa', // Blue
    '#818cf8', // Indigo
    '#a78bfa', // Violet
    '#c084fc', // Purple
    '#e879f9', // Fuchsia
    '#f472b6', // Pink
    '#fb7185', // Rose
    // MEDIUM COLORS (600 variants)
    '#dc2626', // Red
    '#ea580c', // Orange
    '#d97706', // Amber
    '#ca8a04', // Yellow
    '#65a30d', // Lime
    '#16a34a', // Green
    '#059669', // Emerald
    '#0d9488', // Teal
    '#0891b2', // Cyan
    '#0284c7', // Sky
    '#2563eb', // Blue
    '#4f46e5', // Indigo
    '#7c3aed', // Violet
    '#9333ea', // Purple
    '#c026d3', // Fuchsia
    '#db2777', // Pink
    '#e11d48', // Rose
    // DARK COLORS (800 variants)
    '#991b1b', // Red
    '#9a3412', // Orange
    '#92400e', // Amber
    '#854d0e', // Yellow
    '#3f6212', // Lime
    '#166534', // Green
    '#065f46', // Emerald
    '#115e59', // Teal
    '#155e75', // Cyan
    '#075985', // Sky
    '#1e40af', // Blue
    '#3730a3', // Indigo
    '#5b21b6', // Violet
    '#6b21a8', // Purple
    '#86198f', // Fuchsia
    '#9f1239', // Pink
    '#881337' // Rose
];
// Backwards compatibility - keep old exports
export const DEVICE_COLORS = OBJECT_COLORS;
/**
 * Get a random object color from the available options
 */
export function getRandomObjectColor() {
    const randomIndex = Math.floor(Math.random() * OBJECT_COLORS.length);
    return OBJECT_COLORS[randomIndex];
}
// Backwards compatibility
export const getRandomDeviceColor = getRandomObjectColor;
